/**
    @constant RESET
    @desc String constant used to reset an individual config property.
*/
export default "D3PLUS-COMMON-RESET";
